"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = exports.dataHooks = void 0;
var dataHooks = {
  content: 'counter-badge-content'
};
exports.dataHooks = dataHooks;
var SIZES = {
  small: 'small',
  medium: 'medium'
};
exports.SIZES = SIZES;